import type { GraderAction, GraderNavState } from './grader.interface.js';

export {
  INITIAL_JUDGE_FACTORY_NAV_STATE,
  type GraderNavState,
  type GraderAction,
} from './grader.interface.js';

export function graderReducer(
  state: GraderNavState,
  action: GraderAction,
): GraderNavState {
  switch (action.type) {
    case 'SELECT_JUDGE':
      return {
        ...state,
        mode: 'view',
        selectedId: action.id,
        editorTab: 'overview',
      };
    case 'SET_EDITOR_TAB':
      return { ...state, editorTab: action.tab };
    case 'ENTER_CREATE_MODE':
      return {
        ...state,
        mode: 'create',
        creationMethod: action.method,
        selectedId: null,
        editorTab: 'overview',
      };
    case 'EXIT_CREATE_MODE':
      return {
        ...state,
        mode: 'view',
        selectedId: action.selectedId,
        editorTab: 'overview',
      };
    case 'OPEN_DELETE_DIALOG':
      return { ...state, judgeToDelete: action.judge };
    case 'CLOSE_DELETE_DIALOG':
      return { ...state, judgeToDelete: null };
  }
}
